import styled from 'styled-components';

export default styled.div`
  ${({ theme }) => theme.breakpoint('sm', 'md')} {
    display: none;
  }
`;
